var map = {
	"./bare-disclaimer.svg": 7345,
	"./bare.svg": 6411,
	"./qr-disclaimer.svg": 1610,
	"./qr-logo-disclaimer.svg": 7674,
	"./qr-logo.svg": 7330,
	"./qr.svg": 5250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8054;